import { Expose } from 'class-transformer';

export class FormatSelect {
	@Expose({ name: 'id' })
	value: string | undefined;

	@Expose({ name: 'fullname' })
	label: string | undefined;
}
